import clsx from "clsx";
import { Menu as AriaMenu, MenuItem as AriaMenuItem } from "react-aria-components";

import type { MenuProps } from "@/components/ui/Menu/Menu";

type Props = Pick<MenuProps, "items">;

export const MenuList = ({ items }: Props) => {
  return (
    <AriaMenu className="!outline-none focus-visible:!outline-none h-full">
      {items.map(({ label, content, ...item }, index) => (
        <AriaMenuItem
          // oxlint-disable-next-line react/no-array-index-key
          key={index}
          {...item}
          textValue={label}
          aria-label={label}
          className={clsx(
            "flex cursor-pointer items-center justify-center gap-2 px-4 py-1",
            "outline-none",
            "bg-elevation-background text-interactive-text-on-bg",
            "hover:text-interactive-text-hover",
            "focus-visible:bg-interactive-primary-focus focus-visible:text-interactive-text-on-inverted",
            item.className,
          )}
        >
          {content}
        </AriaMenuItem>
      ))}
    </AriaMenu>
  );
};
